module.exports = __webpack_public_path__ + "img/16.cbbd5bc7.jpg";